var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LoadingOverlay',{attrs:{"background-type":_vm.backgroundType.WHITE_BACKGROUND}})}
var staticRenderFns = []

export { render, staticRenderFns }